import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@sm/intl';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import PromptInputAvailable from './PromptInputAvailable';
import PromptInputUnavailable from './PromptInputUnavailable';
const COPY = {
  PromptInputHeader: {
    id: 'buildWithAI.PromptInputBox.PromptInputHeader',
    defaultMessage: 'Make changes with prompts',
    description: '[Type: label][Vis: high] - Header for AI prompt input section of page'
  },
  PromptInputDescription: {
    id: 'buildWithAI.PromptInputBox.PromptInputDescription',
    defaultMessage: 'Type a prompt to add, edit, delete, or change something.',
    description: '[Type: label][Vis: high] - Description for AI prompt input section of page'
  }
};
/**
 * Box containing AI prompt input.
 */
const PromptInputBox = ({
  disabled,
  loading,
  onCancel,
  onFinished,
  onPrompt,
  promptsRemaining
}) => {
  return _jsxs(Box, {
    children: [_jsx(Typography, {
      variant: "cardTitle",
      component: "h2",
      weight: "medium",
      children: t(COPY.PromptInputHeader)
    }), _jsx(Box, {
      mt: 2,
      children: _jsx(Typography, {
        variant: "body",
        children: t(COPY.PromptInputDescription)
      })
    }), _jsx(Box, {
      mt: 4,
      children: promptsRemaining > 0 ? _jsx(PromptInputAvailable, {
        disabled: disabled,
        loading: loading,
        onPrompt: onPrompt,
        promptsRemaining: promptsRemaining
      }) : _jsx(PromptInputUnavailable, {
        onCancel: onCancel,
        onFinished: onFinished
      })
    })]
  });
};
export default PromptInputBox;